import { createFileRoute } from '@tanstack/react-router';
import { HrDashboard } from '@/features/workforce/HrDashboard';

export const Route = createFileRoute('/_app/hr/dashboard')({ component: HrDashboard });
